import { Clickable, Image, P, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { colors, media } = theme;

export const BodyWrapper = styled.div`
  border-top: 1px solid ${colors.grey20};
  padding: 2rem 1rem;

  @media (min-width: ${media.sm}) {
    padding: 2rem;
  }
}
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-height: 12rem;
`;

export const StyledClickable = styled(Clickable)`
  font-weight: 600;
  text-decoration-offset: 3px;
`;

export const StyledDescription = styled(P)`
  max-width: 500px;
`;

export const StyledImage = styled(Image)`
  margin: 0 auto;
`;

export const TileWrapper = styled.div`
  border: 1px solid ${colors.grey20};
  max-width: 600px;
`;
